var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_c('li',[_c('a',{staticClass:"breadcrumbLink",style:(_vm.style),on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("HOME")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }